import { Box, Grid, Typography, Link } from "@mui/material";
import { Link as ReactLink } from "react-router-dom";
const FooterContainer = () => {
  return (
    <Box
      style={{
        background: "#003366",
        width: "100%",
        height: "auto",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        paddingTop: "1.5em",
        paddingBottom: "1.5em",
      }}
    >
      <Box style={{ maxWidth: "960px", width: "100%" }}>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "70%",
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "Images/HKUST_Logo_Footer.png"}
              alt="hkust footer"
              width="15%"
            />
            <Box style={{ marginLeft: "12px" }}>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Link
                  href="https://dataprivacy.ust.hk/university-data-privacy-policy-statement/"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  <Typography> Privacy</Typography>
                </Link>
                <ReactLink
                  to={{ pathname: "/sitemap" }}
                  style={{
                    marginLeft: "12px",
                    textDecoration: "none",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  <Typography>Sitemap</Typography>
                </ReactLink>
              </Box>
              <Typography fontSize="14px" color="white">
                Copyright © The Hong Kong University of Science and Technology.
                All rights reserved.
              </Typography>
            </Box>
          </Box>
          <Grid container wrap="nowrap" width="30%">
            <Grid
              xs={7}
              item
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Typography fontSize="12px" color="white">
                Follow HKUST on
              </Typography>
            </Grid>
            <Grid xs={5} item>
              <Link
                href="https://www.facebook.com/hkust"
                style={{ marginLeft: "4px" }}
              >
                <img
                  src={
                    process.env.PUBLIC_URL + "Images/SocialMedia/facebook.png"
                  }
                  alt="facebook"
                  width="16%"
                />
              </Link>
              <Link
                href="https://www.linkedin.com/school/hkust/"
                style={{ marginLeft: "4px" }}
              >
                <img
                  src={
                    process.env.PUBLIC_URL + "Images/SocialMedia/linkedin.png"
                  }
                  alt="facebook"
                  width="16%"
                />
              </Link>
              <Link
                href="https://www.instagram.com/hkust/"
                style={{ marginLeft: "4px" }}
              >
                <img
                  src={
                    process.env.PUBLIC_URL + "Images/SocialMedia/instagram.png"
                  }
                  alt="facebook"
                  width="16%"
                />
              </Link>
              <Link
                href="https://www.youtube.com/user/HKUST"
                style={{ marginLeft: "4px" }}
              >
                <img
                  src={
                    process.env.PUBLIC_URL + "Images/SocialMedia/youtube.png"
                  }
                  alt="facebook"
                  width="16%"
                />
              </Link>
              <Link
                href="https://hkust.edu.hk/sites/default/files/menu_icons/mainsite_Wechat_Eng_new.jpg"
                style={{ marginLeft: "4px" }}
              >
                <img
                  src={process.env.PUBLIC_URL + "Images/SocialMedia/wechat.png"}
                  alt="facebook"
                  width="16%"
                />
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default FooterContainer;
